
<div class="modal-dialog confirm-dialog">
  <div class="modal-content" style="min-width:550px;">
    <div class="modal-header">
      <h5 class="modal-title">Site Differences</h5>
      <button class="close" type="button" (click)="exit()">&times;</button>
    </div>
    <div class="modal-body">
      <error [error]="error"></error>
      <filtered-list-controls [list]="list" [showSearch]="false" [showLimit]="false"></filtered-list-controls>
      <table class="table table-sm table-responsive" *ngIf="list.filteredLength">
        <thead>
          <tr class="table-header-with-controls no-top-border">
            <th>Field</th>
            <th>TMC</th>
            <th>K2/ACDC/ITSM</th>
            <th class="w1pct"></th>
          </tr>
        </thead>
        <tbody>
          <ng-template ngFor let-item [ngForOf]="list.filtered">
            <tr>
              <td>Site Name</td>
              <td>{{ item.tmcSite.name }}</td>
              <td>{{ item.externalSite.name }}</td>
              <td></td>
            </tr>
            <tr>
              <td>Name 1</td>
              <td>"{{ item.tmcSite.name1 }}"</td>
              <td>"{{ item.externalSite.name1 }}"</td>
              <td><span class="text-red oi oi-x" *ngIf="item.tmcSite.name1 !== item.externalSite.name1"></span></td>
            </tr>
            <tr>
              <td>Name 2</td>
              <td>"{{ item.tmcSite.name2 }}"</td>
              <td>"{{ item.externalSite.name2 }}"</td>
              <td><span class="text-red oi oi-x" *ngIf="item.tmcSite.name2 !== item.externalSite.name2"></span></td>
            </tr>
            <tr>
              <td>Line 1</td>
              <td>"{{ item.tmcSite.line1 }}"</td>
              <td>"{{ item.externalSite.line1 }}"</td>
              <td><span class="text-red oi oi-x" *ngIf="item.tmcSite.line1 !== item.externalSite.line1"></span></td>
            </tr>
            <tr>
              <td>Line 2</td>
              <td>"{{ item.tmcSite.line2 }}"</td>
              <td>"{{ item.externalSite.line2 }}"</td>
              <td><span class="text-red oi oi-x" *ngIf="item.tmcSite.line2 !== item.externalSite.line2"></span></td>
            </tr>
            <tr>
              <td>City</td>
              <td>"{{ item.tmcSite.city }}"</td>
              <td>"{{ item.externalSite.city }}"</td>
              <td><span class="text-red oi oi-x" *ngIf="item.tmcSite.city !== item.externalSite.city"></span></td>
            </tr>
            <tr>
              <td>Region</td>
              <td>"{{ item.tmcSite.region }}"</td>
              <td>"{{ item.externalSite.region }}"</td>
              <td><span class="text-red oi oi-x" *ngIf="item.tmcSite.region !== item.externalSite.region"></span></td>
            </tr>
            <tr>
              <td>Postal Code</td>
              <td>"{{ item.tmcSite.postalCode }}"</td>
              <td>"{{ item.externalSite.postalCode }}"</td>
              <td><span class="text-red oi oi-x" *ngIf="item.tmcSite.postalCode !== item.externalSite.postalCode"></span></td>
            </tr>
            <tr>
              <td>Country</td>
              <td>"{{ item.tmcSite.country }}"</td>
              <td>"{{ item.externalSite.country }}"</td>
              <td><span class="text-red oi oi-x" *ngIf="item.tmcSite.country !== item.externalSite.country"></span></td>
            </tr>
          </ng-template>
          <ng-template [ngIf]="!list.filteredLength">
            <tr>
              <td colspan="4">
                <p class="text-center empty-table-message">There are no sites to display.</p>
              </td>
            </tr>
          </ng-template>
        </tbody>
      </table>
    </div>
    <div class="modal-footer"><span class="font-italic text-red">
        <p class="text-left">Address line differences are highlighted in red</p></span>
      <button class="btn btn-primary" type="button" (click)="exit()">Exit</button>
    </div>
  </div>
</div>